import React, { FC } from 'react'
import { useAnalytics } from 'reactfire'
import { useHistory, Link } from 'react-router-dom'

import {
  // AppleIcon,
  // PhoneIcon,
  EmailIcon,
  // FacebookIcon,
  // AppleLoginIcon,
} from '../Icons'
import { ModalText, ModalHint } from '../Typography'
import { ModalButton } from '../ModalButton'
import { color } from '../../styles'
import { EMAIL_LOGIN, TERMS, PRIVACY } from '../../constants/routes'
import { Modal } from '../Modal'

import {
  Wrap,
  TopSection,
  ButtonGroup,
  Title,
  // DownloadSection,
  // AppStoreButton,
} from './styled'

import { analyticsEvents } from 'src/constants/analytics/events'

interface Props {
  setOpenSignIn: (isOpen: boolean) => void
  openSignIn: boolean
  isCloseAllowed: boolean
}

enum buttonLabels {
  PHONE = 'Continue with Phone',
  EMAIL = 'Continue with Email',
  FACEBOOK = 'Continue with Facebook',
  APPLE = 'Continue with Apple',
}

export const SignIn: FC<Props> = ({
  setOpenSignIn,
  openSignIn,
  isCloseAllowed,
}) => {
  const { logEvent } = useAnalytics()
  const { push } = useHistory()

  const handleEmailLoginClick = () => {
    logEvent(analyticsEvents.continueWithEmail)
    push(EMAIL_LOGIN)
  }

  return (
    <Modal
      isOpen={openSignIn}
      onClose={isCloseAllowed ? () => setOpenSignIn(false) : undefined}
    >
      <Wrap>
        <TopSection>
          <Title>Be cool and sign up</Title>
          <ModalText>Always free, private and secure</ModalText>
          <ButtonGroup>
            {/* <ModalButton color={color.DARK_PASTEL_GREEN} label={buttonLabels.PHONE}>
          <PhoneIcon />
        </ModalButton> */}
            <ModalButton
              color={color.DULL_ORANGE}
              label={buttonLabels.EMAIL}
              onClick={handleEmailLoginClick}
            >
              <EmailIcon />
            </ModalButton>
            {/* <ModalButton color={color.CLEAR_BLUE} label={buttonLabels.FACEBOOK}>
          <FacebookIcon />
        </ModalButton> */}
            {/* <ModalButton color={color.BLACK} label={buttonLabels.APPLE}>
          <AppleLoginIcon />
        </ModalButton> */}
          </ButtonGroup>
          <ModalHint>
            We are intensely committed to your right to privacy.
            <br />
            We will not release or share your individual data.
            <br />
            Our{' '}
            <Link to={TERMS}>
              <span>terms of service</span>
            </Link>{' '}
            and{' '}
            <Link to={PRIVACY}>
              <span>privacy policy</span>
            </Link>{' '}
            reflect this commitment.
            <br />
            By registering, you agree.
          </ModalHint>
        </TopSection>
        {/* <DownloadSection>
        <DownloadText>Download the App</DownloadText>
        <AppStoreButton>
          <AppleIcon />
        </AppStoreButton>
      </DownloadSection> */}
      </Wrap>
    </Modal>
  )
}
